module.exports = __webpack_public_path__ + "img/mylene_farmer_aout_2021.9a3e4159.jpg";